<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChart",
  extends: Bar,

  props: {
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
      }),
    },

    labelsData: {
      type: Array,
      default: null,
    },
    chartData: {
      type: Array,
      default: null,
    },
  },

  mounted() {
    if (!this.labelsData || !this.chartData) return;

    this.renderChart(
      {
        labels: this.labelsData,
        datasets: this.chartData,
      },
      this.chartOptions
    );
  },

  watch: {
    labelsData() {
      this.updateChart();
    },
    chartData() {
      this.updateChart();
    },
  },

  methods: {
    updateChart() {
      if (!this.labelsData || !this.chartData) return;

      this.renderChart(
        {
          labels: this.labelsData,
          datasets: this.chartData,
        },
        this.chartOptions
      );
    },
  },
};
</script>

<style scoped>
:host {
  display: block;
  height: 260px;
}
</style>
